import { render, staticRenderFns } from "./ReportingLegacy.vue?vue&type=template&id=2b3bd914&"
import script from "./ReportingLegacy.vue?vue&type=script&lang=js&"
export * from "./ReportingLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports